export const FeatureContent = [
    {
        title: "Highly Customizable",
        text: `Use our default metadata parsed from your sample or upload 
        your own custom metadata to change the color and search filter. 
        Custom metadata will appear in the tooltip. Easily change gene/annotation coloring.
        Delete or add multiple tracks. 
        Add genes to a legend. Click the genes on the legend to border them 
        on the plot. Exportable for publication-quality images in SVG.`
    },
    {
        title: "Interactive",
        text: `Zoom and pan on the main chart by interacting with the white space.
        Use the search filter to find your gene. Hover over the gene to reveal more information parsed from your sample.
        Rearrange the track order by dragging
        the bar symbol on the label. Click on a gene to highlight that gene throughout
        the plot.`
    },
    {
        title: "Gene Centering",
        text: `Center the visualization on a new gene by selecting the centering option from the right-click menu of your gene of interest.
        Drag individual tracks
        by clicking and dragging to realign to your preference. Flip individual tracks to view their alternate orientation.`
    },
    {
        title: "Connect With Annotree",
        text: `Explore subsets of genomic regions from our Annotree database, drawing from over 27,000
        bacterial and 1,500 archael genomes.`
    },
]